import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 m-3"
}
const _hoisted_2 = { class: "assets-grid-card" }
const _hoisted_3 = { class: "assets-grid-card__header" }
const _hoisted_4 = { class: "assets-grid-title" }
const _hoisted_5 = { class: "assets-grid-title__text" }
const _hoisted_6 = { class: "assets-grid-controls" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "assets-grid-card__body" }
const _hoisted_9 = { class: "wl-assets-search-wrap d-flex align-items-center gap-3 flex-wrap" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "form-check mb-0" }
const _hoisted_12 = {
  class: "form-check-label text-muted small",
  for: "onlyOfflineGateways"
}
const _hoisted_13 = {
  key: 0,
  class: "wp-grid-wrap"
}
const _hoisted_14 = {
  key: 0,
  class: "wp-loading wp-loading--overlay"
}
const _hoisted_15 = { class: "wp-loading__text" }
const _hoisted_16 = { class: "text-muted small font-monospace" }
const _hoisted_17 = { class: "text-muted small font-monospace" }
const _hoisted_18 = { class: "assets-grid-card ni-grid-card--spaced" }
const _hoisted_19 = { class: "assets-grid-card__header" }
const _hoisted_20 = { class: "assets-grid-title" }
const _hoisted_21 = { class: "assets-grid-title__text" }
const _hoisted_22 = { class: "assets-grid-controls" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "assets-grid-card__body" }
const _hoisted_25 = { class: "wl-assets-search-wrap d-flex align-items-center gap-3 flex-wrap" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = { class: "form-check mb-0" }
const _hoisted_28 = {
  class: "form-check-label text-muted small",
  for: "onlyOfflineAnchors"
}
const _hoisted_29 = {
  key: 0,
  class: "wp-grid-wrap"
}
const _hoisted_30 = {
  key: 0,
  class: "wp-loading wp-loading--overlay"
}
const _hoisted_31 = { class: "wp-loading__text" }
const _hoisted_32 = { class: "font-monospace small" }
const _hoisted_33 = { class: "text-muted small font-monospace" }
const _hoisted_34 = { class: "assets-grid-title" }
const _hoisted_35 = { class: "assets-grid-title__text" }
const _hoisted_36 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mb-3"
}
const _hoisted_37 = {
  key: 1,
  class: "form-check"
}
const _hoisted_38 = {
  class: "form-check-label",
  for: "deleteHistoryChecked"
}
const _hoisted_39 = {
  key: 2,
  class: "text-muted small mb-0"
}
const _hoisted_40 = { class: "d-flex justify-content-between w-100" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[13] || (_cache[13] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.error), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
            _createElementVNode("i", { class: "bi bi-hdd-network" })
          ], -1)),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('components.infrastructure.dataCleanup.gatewaysTitle')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "assets-toolbar-btn assets-toolbar-btn--danger",
            disabled: _ctx.selectedGatewayIds.length === 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDeleteConfirm('gateway')))
          }, [
            _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-trash" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.dataCleanup.deleteSelected', { n: _ctx.selectedGatewayIds.length })), 1)
          ], 8, _hoisted_7)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.gatewaySearch) = $event)),
            type: "text",
            class: "form-control wl-assets-search",
            placeholder: _ctx.$t('components.infrastructure.dataCleanup.searchPlaceholder'),
            onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onGatewaySearchInput && _ctx.onGatewaySearchInput(...args)))
          }, null, 40, _hoisted_10), [
            [_vModelText, _ctx.gatewaySearch]
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              id: "onlyOfflineGateways",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.onlyOfflineGateways) = $event)),
              type: "checkbox",
              class: "form-check-input",
              onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.refreshGateways && _ctx.refreshGateways(...args)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.onlyOfflineGateways]
            ]),
            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('components.infrastructure.dataCleanup.onlyOffline')), 1)
          ])
        ]),
        (_ctx.hasActivated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_ctx.gatewaysLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", {
                      class: "spinner-border wp-loading__spinner",
                      role: "status"
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('components.infrastructure.loading')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_DxDataGrid, {
                ref: "gatewaysGridRef",
                class: "ni-grid",
                "data-source": _ctx.gatewaysDataSource,
                "remote-operations": true,
                "column-auto-width": true,
                "key-expr": "gwId",
                "hover-state-enabled": true,
                "show-borders": false,
                "show-column-lines": false,
                "show-row-lines": false,
                "row-alternation-enabled": true,
                "word-wrap-enabled": false,
                "no-data-text": _ctx.$t('components.infrastructure.dataCleanup.gatewaysEmpty'),
                onSelectionChanged: _ctx.onGatewaySelectionChanged
              }, {
                "gwid-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(data.data.gwId), 1)
                ]),
                "updated-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.agoText(data.data.updatedAt)), 1)
                ]),
                "gwstatus-template": _withCtx(({ data }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["wirepas-status-badge", data.data.state === 'online' ? 'wirepas-status-badge--online' : 'wirepas-status-badge--offline'])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["wirepas-status-dot", data.data.state === 'online' ? 'wirepas-status-dot--online' : 'wirepas-status-dot--offline'])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(data.data.state === 'online' ? _ctx.$t('components.infrastructure.online') : _ctx.$t('components.infrastructure.offline')), 1)
                  ], 2)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_DxSelection, {
                    mode: "multiple",
                    "show-check-boxes-mode": "always"
                  }),
                  _createVNode(_component_DxLoadPanel, { enabled: false }),
                  _createVNode(_component_DxPaging, { "page-size": 10 }),
                  _createVNode(_component_DxPager, {
                    "allowed-page-sizes": [10, 20, 50],
                    "show-info": true,
                    "show-page-size-selector": true,
                    "show-navigation-buttons": true
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "gwId",
                    caption: _ctx.$t('components.infrastructure.gateways.columns.gwId'),
                    "min-width": 150,
                    "allow-sorting": false,
                    "cell-template": "gwid-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "locationName",
                    caption: _ctx.$t('components.infrastructure.gateways.columns.location'),
                    "min-width": 160,
                    "allow-sorting": false
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "state",
                    caption: _ctx.$t('components.infrastructure.gateways.columns.status'),
                    "min-width": 110,
                    alignment: "center",
                    "allow-sorting": false,
                    "cell-template": "gwstatus-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "updatedAt",
                    caption: _ctx.$t('components.infrastructure.gateways.columns.updatedAt'),
                    "min-width": 160,
                    "allow-sorting": false,
                    "cell-template": "updated-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "assetCount",
                    caption: _ctx.$t('components.infrastructure.gateways.columns.assetCount'),
                    "min-width": 100,
                    alignment: "center",
                    "allow-sorting": false
                  }, null, 8, ["caption"])
                ]),
                _: 1
              }, 8, ["data-source", "no-data-text", "onSelectionChanged"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
            _createElementVNode("i", { class: "bi bi-broadcast" })
          ], -1)),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('components.infrastructure.dataCleanup.anchorsTitle')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("button", {
            type: "button",
            class: "assets-toolbar-btn assets-toolbar-btn--danger",
            disabled: _ctx.selectedAnchorAddresses.length === 0,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openDeleteConfirm('anchor')))
          }, [
            _cache[18] || (_cache[18] = _createElementVNode("i", { class: "bi bi-trash" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.infrastructure.dataCleanup.deleteSelected', { n: _ctx.selectedAnchorAddresses.length })), 1)
          ], 8, _hoisted_23)
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.anchorSearch) = $event)),
            type: "text",
            class: "form-control wl-assets-search",
            placeholder: _ctx.$t('components.infrastructure.anchors.searchPlaceholder'),
            onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onAnchorSearchInput && _ctx.onAnchorSearchInput(...args)))
          }, null, 40, _hoisted_26), [
            [_vModelText, _ctx.anchorSearch]
          ]),
          _createElementVNode("div", _hoisted_27, [
            _withDirectives(_createElementVNode("input", {
              id: "onlyOfflineAnchors",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.onlyOfflineAnchors) = $event)),
              type: "checkbox",
              class: "form-check-input",
              onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.refreshAnchors && _ctx.refreshAnchors(...args)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.onlyOfflineAnchors]
            ]),
            _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('components.infrastructure.dataCleanup.onlyOffline')), 1)
          ])
        ]),
        (_ctx.hasActivated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              (_ctx.anchorsLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _cache[19] || (_cache[19] = _createElementVNode("span", {
                      class: "spinner-border wp-loading__spinner",
                      role: "status"
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('components.infrastructure.loading')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_DxDataGrid, {
                ref: "anchorsGridRef",
                class: "ni-grid",
                "data-source": _ctx.anchorsDataSource,
                "remote-operations": true,
                "column-auto-width": true,
                "key-expr": "address",
                "hover-state-enabled": true,
                "show-borders": false,
                "show-column-lines": false,
                "show-row-lines": false,
                "row-alternation-enabled": true,
                "word-wrap-enabled": false,
                "no-data-text": _ctx.$t('components.infrastructure.dataCleanup.anchorsEmpty'),
                onSelectionChanged: _ctx.onAnchorSelectionChanged
              }, {
                "addr-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(data.data.address), 1)
                ]),
                "anchor-updated-template": _withCtx(({ data }) => [
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.agoText(data.data.lastSeen)), 1)
                ]),
                "anchor-status-template": _withCtx(({ data }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["wirepas-status-badge", data.data.active ? 'wirepas-status-badge--online' : 'wirepas-status-badge--offline'])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["wirepas-status-dot", data.data.active ? 'wirepas-status-dot--online' : 'wirepas-status-dot--offline'])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(data.data.active ? _ctx.$t('components.infrastructure.anchors.status.active') : _ctx.$t('components.infrastructure.anchors.status.silent')), 1)
                  ], 2)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_DxSelection, {
                    mode: "multiple",
                    "show-check-boxes-mode": "always"
                  }),
                  _createVNode(_component_DxLoadPanel, { enabled: false }),
                  _createVNode(_component_DxPaging, { "page-size": 10 }),
                  _createVNode(_component_DxPager, {
                    "allowed-page-sizes": [10, 20, 50],
                    "show-info": true,
                    "show-page-size-selector": true,
                    "show-navigation-buttons": true
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "address",
                    caption: _ctx.$t('components.infrastructure.anchors.columns.address'),
                    "min-width": 130,
                    "allow-sorting": false,
                    "cell-template": "addr-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "lastSeen",
                    caption: _ctx.$t('components.infrastructure.anchors.columns.lastSeen'),
                    "min-width": 160,
                    "allow-sorting": false,
                    "cell-template": "anchor-updated-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "active",
                    caption: _ctx.$t('components.infrastructure.anchors.columns.status'),
                    "min-width": 110,
                    alignment: "center",
                    "allow-sorting": false,
                    "cell-template": "anchor-status-template"
                  }, null, 8, ["caption"]),
                  _createVNode(_component_DxColumn, {
                    "data-field": "tagsHeard",
                    caption: _ctx.$t('components.infrastructure.anchors.columns.tagsHeard'),
                    "min-width": 100,
                    alignment: "center",
                    "allow-sorting": false
                  }, null, 8, ["caption"])
                ]),
                _: 1
              }, 8, ["data-source", "no-data-text", "onSelectionChanged"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_base_modal, {
      ref: "confirmModalRef",
      size: "md"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_34, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
            _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" })
          ], -1)),
          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('components.infrastructure.dataCleanup.confirmTitle')), 1)
        ])
      ]),
      body: _withCtx(() => [
        (_ctx.deleteError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _cache[21] || (_cache[21] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.deleteError), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, _toDisplayString(_ctx.deleteContext === 'gateway'
            ? _ctx.$t('components.infrastructure.dataCleanup.confirmTextGateways', { n: _ctx.selectedGatewayIds.length })
            : _ctx.$t('components.infrastructure.dataCleanup.confirmTextAnchors', { n: _ctx.selectedAnchorAddresses.length })), 1),
        (_ctx.deleteContext === 'gateway')
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _withDirectives(_createElementVNode("input", {
                id: "deleteHistoryChecked",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.deleteHistoryChecked) = $event)),
                type: "checkbox",
                class: "form-check-input"
              }, null, 512), [
                [_vModelCheckbox, _ctx.deleteHistoryChecked]
              ]),
              _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('components.infrastructure.dataCleanup.deleteHistory')), 1)
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(_ctx.$t('components.infrastructure.dataCleanup.anchorHistoryNote')), 1))
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteConfirm && _ctx.closeDeleteConfirm(...args)))
          }, _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.close')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-danger",
            disabled: _ctx.deleting,
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
          }, [
            (_ctx.deleting)
              ? (_openBlock(), _createElementBlock("span", _hoisted_42))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('components.infrastructure.dataCleanup.confirmDelete')), 1)
          ], 8, _hoisted_41)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}